import React  from "react";
export default function VideoModal(props) {

const v = props['id'];
 
    return (
        
        <div className="modal fade" id="fullscreenModal">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Learning Outcome Video</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                <section className="section">
                    <div className="card">
                        <div className="card-body">
                            {/* {v} */}
                        <video width="750" height="500" controls >
                            <source src={v} type="video/mp4"/>
                        </video>
     
                        </div>
                    </div>
                </section>
            </div>
            <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    );
}